// File: Nav.jsx

import { NavLink, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import React from 'react';
import { authActions } from '../../_store';
import './nav.css';
import logo from '../../assets/img/logo.svg';

export function Nav() {
    const auth = useSelector((x) => x.auth.value);
    const navProps = useSelector((x) => x.auth.navProps); // Get the props passed from Login component
    const dispatch = useDispatch();

    return (
        <nav className='navbar navbar-expand'>
            <div className='d-grid gap-0 w-100'>
                <div className='navbar-nav header'>
                    <NavLink to='/' className='nav-item nav-link'>
                        <img src={logo} alt='logo' className='splendi-logo' />
                    </NavLink>
                    <div className='account'>
                        <div>
                            <label className='nav-item m-3'>
                                {navProps?.status || "Don't have an account?"}
                            </label>
                        </div>
                        <div>
                            <Link
                                to={
                                    navProps?.action === '../register'
                                        ? '/register'
                                        : '/'
                                }
                                className='btn btn-primary'
                            >
                                {navProps?.button || 'Register'}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className='w-100 rounded-0 mt-0 btn btn-primary'>
                    {navProps?.title || 'LOGIN TO SPLENDI'}
                </div>
            </div>
        </nav>
    );
}
